import { createContext, useContext, useMemo } from 'react';

const PeopleDirectoryContext = createContext();

export const PeopleDirectoryProvider = ({
  canDisplayMap,
  children,
  config,
  currentFilterLocationBounds,
  currentPage,
  fetchSelectedUser,
  filters,
  geoBoundingBoxFilter,
  isSearchingOnMapBounds,
  mapToggleChecked,
  resetFilters,
  selectedUser,
  setCurrentPage,
  setGeoBoundingBoxFilter,
  setIsSearchingOnMapBounds,
  setMapToggleChecked,
  setResultsAreEmpty,
  setSelectedUser,
  setSortBy,
  sortBy,
  updateFilters,
}) => {
  const providerState = useMemo(
    () => ({
      canDisplayMap,
      config,
      currentFilterLocationBounds,
      currentPage,
      fetchSelectedUser,
      filters,
      geoBoundingBoxFilter,
      isSearchingOnMapBounds,
      mapToggleChecked,
      resetFilters,
      selectedUser,
      setCurrentPage,
      setGeoBoundingBoxFilter,
      setIsSearchingOnMapBounds,
      setMapToggleChecked,
      setResultsAreEmpty,
      setSelectedUser,
      setSortBy,
      sortBy,
      updateFilters,
    }),
    [
      canDisplayMap,
      config,
      currentFilterLocationBounds,
      currentPage,
      fetchSelectedUser,
      filters,
      geoBoundingBoxFilter,
      isSearchingOnMapBounds,
      mapToggleChecked,
      resetFilters,
      selectedUser,
      setCurrentPage,
      setGeoBoundingBoxFilter,
      setIsSearchingOnMapBounds,
      setMapToggleChecked,
      setResultsAreEmpty,
      setSelectedUser,
      setSortBy,
      sortBy,
      updateFilters,
    ],
  );

  return (
    <PeopleDirectoryContext.Provider value={providerState}>
      {children}
    </PeopleDirectoryContext.Provider>
  );
};

export const usePeopleDirectoryContext = () =>
  useContext(PeopleDirectoryContext);

export const withPeopleDirectoryContext = (Component) => (props) => {
  const contextValue = usePeopleDirectoryContext();

  return <Component {...contextValue} {...props} />;
};

export default PeopleDirectoryContext;
